import React, { useContext, useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import MainLayout from "../layouts/MainLayout";

const PrivateRoute = ({ noLayout = false, children }) => {
  const { bearerToken, setRedirectPath } = useContext(AuthContext);
  const location = useLocation();
  const [isAuthenticating, setIsAuthenticating] = useState(true);

  useEffect(() => {
    if (!bearerToken) {
      setRedirectPath(location.pathname); // Salva a rota para redirecionamento
    }
    setIsAuthenticating(false); // Finaliza verificação de autenticação
  }, [bearerToken, location.pathname, setRedirectPath]);

  if (isAuthenticating) {
    // Exibe um spinner ou mensagem enquanto verifica autenticação
    // return <Box display="flex" justifyContent="center" alignItems="center" height="100%">
    //   <CircularProgress />
    // </Box>;
  }

  if (!bearerToken) {
    const p = location.pathname || "";
    if (p.startsWith("/partner") && !p.startsWith("/partner/login")) {
      return <Navigate to="/partner/login" replace state={{ from: `${location.pathname}${location.search || ""}` }} />;
    }
    if (p.startsWith("/platform") && !p.startsWith("/platform/login")) {
      return <Navigate to="/platform/login" replace state={{ from: `${location.pathname}${location.search || ""}` }} />;
    }
    return <Navigate to="/login" />;
  }

  // Renderiza rotas protegidas com ou sem layout
  return noLayout ? children : <MainLayout><Outlet /></MainLayout>;
};

export default PrivateRoute;
